import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { createRoot } from 'react-dom/client';
import { registerLogHandlers } from './common/utils/LogUtils';
import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID!!,
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID!!,
    },
  },
});

// Dev-only debug helpers: Vite doesn't resolve bare module specifiers in the
// DevTools console, so expose Hub / fetchAuthSession / signOut on window for
// manual testing of the auth refresh + signOut paths. Stripped from prod by
// the `import.meta.env.DEV` gate.
if (import.meta.env.DEV) {
  Promise.all([import('aws-amplify/utils'), import('@aws-amplify/auth')])
    .then(([{ Hub }, { fetchAuthSession, signOut }]) => {
      (window as unknown as { __authDebug: unknown }).__authDebug = { Hub, fetchAuthSession, signOut };
      console.log('🔧 __authDebug ready: { Hub, fetchAuthSession, signOut }');
    });
}

const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

registerLogHandlers();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
